import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { COURSE_MODE } from '@/courses/enums/course-edition.enum';
import { ContentType } from '@/content/types/content.types';
import { Section } from '@/courses/models/section.model';
import { SectionProvider } from '@/sections/providers/section.provider';
import { EdSectionOptions } from '@/content/models/ed-section-options.model';
import Course from '@/content/models/course.model';
import { COMPONENT_TYPE } from '@/courses/values/courses.values'

@Component({
  name: 'ed-deck-library-sections',
  components: {
    EdContentSidebarSection: () => import(/* EdContentSidebarSection */'@/sections/components/ed-content-sidebar-section/ed-content-sidebar-section.component.vue'),
  }
})
export default class EdDeckLibrarySectionsComponent extends Vue  {

  @Prop({ default: null }) readonly contentId: number;
  @Prop({ default: null }) readonly classId: number;
  @Prop({ default: COURSE_MODE.VIEWER }) readonly mode: COURSE_MODE;
  @Prop({ default: 'SUBJECT' }) readonly contentType: ContentType;
  @Prop({ default: () => [] }) readonly course: Course;
  @Prop({ default: false }) readonly loading: boolean;
  @Prop({ default: false }) readonly loaded: boolean;
  @Prop({ default: null }) readonly options: EdSectionOptions;
  @Prop({ default: false }) readonly isProject: boolean;

  readonly componentName: string = COMPONENT_TYPE.DECK_CREATOR.code;

  get isShownWithoutContent(): boolean {
    return true;
  }

  get isEmpty(){
    if(this.deckLibrary && this.deckLibrary.sections){
      return this.deckLibrary.sections.length === 0 
    }
    return true;
  }

  get deckLibrary(): Section{
    return this.course.deckLibrary;
  }

  get decks() {
    return this.deckLibrary ? this.deckLibrary.sections : [];
  }

  get deckOptions(): EdSectionOptions{
    return {
      draggable: true,
      selectable: this.options.selectable,
      editable: this.options.editable,
      objectOptions: this.options.objectOptions
    }
  }

  goToAddDeck() {
    SectionProvider.openDeckCreator(
      this.contentId,
      this.classId,
      this.deckLibrary,
      'DECK_LIBRARY'
    );
  }
}